import moment from "moment";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import axios from "axios";

const Map = forwardRef(({ ...props }, ref) => {
  const mapRef = useRef(null);
  useEffect(() => {
    // googleMap();
  }, []);

  useImperativeHandle(ref, () => ({
    googleMap(data) {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBepP9yk1xgkLK35HZCksXxyEqxQCxGIAM&libraries=geometry`; // 🔑 Replace YOUR_API_KEY
      googleMapScript.async = true;
      window.document.body.appendChild(googleMapScript);

      googleMapScript.addEventListener("load", () => {
        const map = new window.google.maps.Map(mapRef.current, {
          center: { lat: 0, lng: 0 },
          zoom: 2,

          mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        });

        const bounds = new window.google.maps.LatLngBounds();
        const infowindow = new window.google.maps.InfoWindow();
      
        data.forEach((item) => {
          const latlng = item.start_time_latlong.split(",");
          const lat = parseFloat(latlng[0]);
          const lng = parseFloat(latlng[1]);
          const position = new window.google.maps.LatLng(lat, lng);

          const isWorking =
            !item.project_end_time || item.project_end_time === "null";

          const icon = isWorking
            ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png" // currently working
            : "http://maps.google.com/mapfiles/ms/icons/red-dot.png"; // completed

          // Create the marker with custom icon
          const marker = new window.google.maps.Marker({
            position,
            map,
            icon, // <-- Apply icon
          });

          // Extend bounds for this marker
          bounds.extend(position);

          // Add click listener for infowindow
          marker.addListener("click", () => {
            const content = `
    <div style="font-size: 14px;">
      📍 <strong>Project Name:</strong> ${item.project_name}<br/>
      ⏰ <strong>Start Time:</strong> ${item.project_start_time}<br/>
      🕔 <strong>End Time:</strong> ${
        item.project_end_time ? item.project_end_time : "Currently Working"
      }<br/>
      ⌛ <strong>Total Hours:</strong> ${item.hours_of_working ?? "-"}
    </div>
  `;
            infowindow.setContent(content);
            infowindow.open(map, marker);
          });
        });

        // Fit the map to the bounds containing all markers
        map.fitBounds(bounds);
      });
    },
  }));
  return <div style={{ height: "500px" }} ref={mapRef} />;
});

export default Map;
